<template>
  <div class="bg-blue-dark p-4 pb-8 flex items-center mb-4">
    <img
      :src="$store.state.user.gravatar"
      alt=""
      class="rounded-full w-10 h-10 mr-4 shadow-lg"
    >
    <div class="flex-col">
      <h4 class="text-white tracking-wide">{{$store.state.user.name}}</h4>
      <div class="text-right text-xxs text-white">Logout</div>
    </div>
  </div>
</template>

<script>
export default {};
</script>




// WEBPACK FOOTER //
// LoggedUserSection.vue?4b862b7c